export default {
	assignGuide: "Vincular Guía",
	editGuide: "Editar Relación",
	filters: {
		active: "Activos",
	},
	tabs: {
		link: "Existente",
		createNew: "Crear nuevo",
	},
};
